import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { formatTodayDate } from '@Utils/String';
import Button from '@Components/Button';
import StructureDataContainer from '@Containers/Breadcrumbs/BreadcrumbTooltip/StructureData';

import './BreadcrumbTooltipContent.theme.scss';

function BreadcrumbTooltipContent({ header, breadcrumb, isAlertVisible, createAlert }) {
  const createAlertClickHandler = useCallback(() => {
    createAlert(breadcrumb.toJS());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumb]);

  return (
    <div className="new-breadcrumbs__tooltip-content results-breadcrumb-tooltip-content" title={breadcrumb.getIn(['formated', 'comment'])}>
      <h4>{header}</h4>
      <time className="results-breadcrumb-tooltip-content__time" dateTime={breadcrumb.get('creationTime')}>
        {formatTodayDate(breadcrumb.get('creationTime'))}
      </time>
      <div className="results-breadcrumb-tooltip-content__description">
        <StructureDataContainer breadcrumb={breadcrumb} />
      </div>
      {isAlertVisible && (
        <div className="results-breadcrumb-tooltip-content__alert-item">
          <Button
            buttonConfig={{ type: 'primary', label: 'Alert', size: 'sm', title: 'Alerts', e2eName: 'breadcrumb-alert' }}
            iconConfig={{ name: 'notifications', size: 'md' }}
            onClick={createAlertClickHandler}
          />
        </div>
      )}
    </div>
  );
}

BreadcrumbTooltipContent.propTypes = {
  header: PropTypes.node,
  breadcrumb: PropTypes.object,
  isAlertVisible: PropTypes.bool,
  createAlert: PropTypes.func,
};

export default BreadcrumbTooltipContent;
